// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__15ZJO","errorLogs":"styles_errorLogs__2re8w"};